import { HttpService } from "./http.service";
import { Injectable, inject } from "@angular/core";
import type { fhirR4 } from "@smile-cdr/fhirts";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { SupportedOrderTypes } from "./order.service";

export class GroupedBundle {
  Patient: fhirR4.Patient[] = [];
  ServiceRequest: fhirR4.ServiceRequest[] = [];
  DeviceRequest: fhirR4.DeviceRequest[] = [];
  NutritionOrder: fhirR4.NutritionOrder[] = [];
  MedicationRequest: fhirR4.MedicationRequest[] = [];
  CommunicationRequest: fhirR4.CommunicationRequest[] = [];
  VisionPrescription: fhirR4.VisionPrescription[] = [];
  Practitioner: fhirR4.Practitioner[] = [];
  PractitionerRole: fhirR4.PractitionerRole[] = [];
  Coverage: fhirR4.Coverage[] = [];
  Observation: fhirR4.Observation[] = [];
  Condition: fhirR4.Condition[] = [];
  Encounter: fhirR4.Encounter[] = [];
  Device: fhirR4.Device[] = [];
  Medication: fhirR4.Medication[] = [];
  Organization: fhirR4.Organization[] = [];
  Endpoint: fhirR4.Endpoint[] = [];
}

export class TaskDetail {
  order: string;
  task?: fhirR4.Task;
  incomplete?: boolean;
}
@Injectable({
  providedIn: "root",
})
export class FhirdataService {
  private httpService = inject(HttpService);


  processEntriesBundle(data: fhirR4.Bundle) {
    const entryList = new GroupedBundle();
    // Separate entries in bundle
    if (data?.entry) {
      data.entry.forEach((entry: fhirR4.BundleEntry) => {
        entryList[entry?.resource?.resourceType].push(entry.resource);
      });
    }
    return entryList;
  }
  async getTaskDetails(reference: string): Promise<fhirR4.Task> {
    const getTaskUrl = `${environment.resourceProviderURI}/${reference}`;
    return await firstValueFrom(
      this.httpService.executeGETQueryWithParams<fhirR4.Task>(getTaskUrl)
    );
  }

  async hasIncompletePasTask(order: SupportedOrderTypes): Promise<TaskDetail> {
    const taskReference = order.extension
      ?.filter((ext) => ext.url.endsWith("pas-cdex-reference"))
      .flatMap((ext) =>
        ext.extension
          .filter((ext) => ext?.url.endsWith("pas-task-reference"))
          .map((ext) => ext.valueReference.reference)
      )
      .pop();
    if (taskReference) {
      try {
        const task = await this.getTaskDetails(taskReference);
        return {
          order: order.id,
          task,
          incomplete: task.status !== "completed",
        };
      } catch (error) {
        console.log(error);
      }
    }
    return { order: order.id, incomplete: undefined };
  }
}
